import { useEffect, useState } from "react";
import "./transfer.css";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Button, Table, Accordion, Dropdown } from "react-bootstrap";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";
import {
  addData,
  fetchAllData,
  getAllData,
  updateUser,
} from "../../Utility/API";
import moment from "moment-timezone";
import { endPoints, paymentEndpoints } from "../../constant/Environment";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { Actions } from "../../redux/Actions/Actions";
import { sumSC_credit_SC_Main } from "../../Utility/functions/Helper";
const Transfer = () => {
  const User = useSelector((state) => state?.auth?.user?.data);
  const dispatch = useDispatch();
  const [adminBal, setAdminBal] = useState(User?.account?.balance || "");
  const [isLoading, setIsLoadinig] = useState(false);
  const [admin, setAdmin] = useState({});
  const [riskmng, setRiskMng] = useState({});
  const [allusers, setAllusers] = useState([]);
  const [showall, setShowAll] = useState(false);
  const [showother, setShowOther] = useState(false);
  const [selected, setSelected] = useState({});
  const [isAdmin, setIsAdmin] = useState(false);
  const [amount, setAmount] = useState("");
  const [amountEnter, setAmountEnter] = useState("");
  const [type, setType] = useState("Gold");
  const [checked, setChecked] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchEmail, setSearchEmail] = useState("");
  const [selectAmountInput, setSelectAmountInput] = useState("");

  const [searchid, setSearchid] = useState("");
  const [description, setDescription] = useState("");

  const [requestType, setRequestType] = useState("Deposit");
  const [requestChecked, setrequestChecked] = useState(false);

  const [hideTransChecked, setHideTransChecked] = useState(false);

  useEffect(() => {
    getAll();
  }, []);
  const getAll = () => {
    let url1 = endPoints.api.GET_ADMIN;
    let url2 = endPoints.api.GET_RISKMANAGER;
    let url3 = endPoints.api.GET_ALL_USERS;
    setIsLoadinig(true);
    const Promise1 = getAllData(url1);
    const Promise2 = getAllData(url2);
    const Promise3 = getAllData(url3);
    Promise.all([Promise1, Promise2, Promise3])
      .then((response) => {
        setIsLoadinig(false);
        let result1 = response[0]?.data;
        setAdmin(result1);
        let result2 = response[1]?.data;
        setRiskMng(result2);
        setSelected(result2);
        let result3 = response[2]?.data;
        setAllusers(result3);
      })
      .catch((err) => {
        setIsLoadinig(false);
        console.log(err);
      });
  };
  const handleChange = (event) => {
    let value = event.target.value.replace(/[^0-9.]/g, "");
    setAmountEnter(value);
  };
  const WithdrawDeposit = () => {
    if (amountEnter !== "" && type !== "" && requestType !== "") {
      // let data = {
      //   description: description,
      //   type: type === "Deposit" ? 1 : 2,
      //   id_user: selected?.idUser,
      //   amount: amountEnter,
      //   referred_user: selected?.idUser,
      //   id_session: User?.sessionId,
      //   id_account: User?.idUser,
      //   transaction_id: "string",
      //   external_id: "string",
      //   pin: 0,
      //   balanceType : selectAmountInput == 'Bouns' ? "bouns" : 'balance' ,
      // };
      let data = {
        userId: selected?.idUser,
        coinType: type,
        transferType: requestType,
        amount: amountEnter,
        description: description,
        hideUserTrans: hideTransChecked,
      };
      console.log("data", data);

      let url = endPoints.api.DEPOSIT_COIN;
      let url1 = endPoints.api.WITHDRAW_COIN;
      setIsLoadinig(true);
      addData(requestType === "Deposit" ? url : url1, data)
        .then((response) => {
          setIsLoadinig(false);

          // UpdateAdmin();
          if (response.data.status === "success") {
            requestType === "Deposit"
              ? SuccesToast("Coins Deposit Succesfully")
              : SuccesToast("Coins Withdrawn Succesfully");
            setAmountEnter("");
            setDescription("");

            onUserClick(selected);
          } else {
            ErrorToast(response?.data.message);
          }
        })
        .catch((err) => {
          setIsLoadinig(false);
          console.log(err);
        });
    } else {
      amountEnter === ""
        ? ErrorToast("Enter Coins")
        : ErrorToast("Select Request/Coin Type");
    }
  };
  const onUserClick = (item) => {
    console.log("tem.idUser", item.idUser);
    let url = `${endPoints.api.GET_BY_USERID}/${item.idUser}`;
    setIsLoadinig(true);
    getAllData(url)
      .then((response) => {
        setIsLoadinig(false);
        if (response.status === "success") {
          setSelected(response?.data);
          setAmount(response?.data?.account?.balance);
        }
      })
      .catch((err) => {
        setIsLoadinig(false);
        console.log(err);
      });
    setIsAdmin(false);
  };
  const onAdminClick = () => {
    setIsAdmin(true);
    setSelected(admin);
  };
  const UpdateAdmin = () => {
    let url = `${endPoints.api.GET_BY_USERID}/${User?.idUser}`;
    getAllData(url)
      .then((response) => {
        if (response.status === "success") {
          setAdminBal(response.data?.account?.balance);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const filteredData = allusers.filter((item2) => {
    const login = item2.login.toLowerCase().includes(searchQuery.toLowerCase());
    const idUser = item2.idUser.toString().includes(searchid);
    const email = item2.email.toLowerCase().includes(searchEmail.toLowerCase());
    return login && idUser && email;
  });

  const filterList = (e) => {
    setSearchQuery(e.target.value);
  };


  const seacrhUser =async()=>{
   console.log('seacrj value',searchQuery)
       let url = `${endPoints.api.GET_ALL_USERS}?search=${searchQuery}`;
        setIsLoadinig(true);
         const result = await getAllData(url);
        //  console.log('result',result)
               setIsLoadinig(false);
         if(result.status =="success"){
            setAllusers(result.data);
         }
  }

  const filterList2 = (e) => {
    setSearchid(e.target.value);
  };
  const filterList3 = (e) => {
    setSearchEmail(e.target.value);
  };

  //console.log('type',type)
  return (
    <div className="main">
      <Toaster></Toaster>
      {isLoading && <Loader spinner={true} visible={isLoading} />}
      <div class="manager_central">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-3">
              <div class="left_manager full_manager_div">
                <div class="box_effect">
                  <h3>USER DATA</h3>
                </div>
                <div class="sub_manager">
                  <h3>Personal Information</h3>
                </div>

                {!isAdmin && (
                  <div class="manager_table">
                    <table class="table table-hover">
                      <tbody>
                        <tr>
                          <td>Name: </td>
                          <td>{selected?.name}</td>
                        </tr>
                        <tr>
                          <td>Surname: </td>
                          <td>{selected?.surname}</td>
                        </tr>
                        <tr>
                          <td>Gender: </td>
                          <td>{selected?.sex}</td>
                          {/* <input type="text" name="" /> */}
                        </tr>
                        <tr>
                          <td>Language: </td>
                          <td>{selected?.language} </td>
                        </tr>
                        <tr>
                          <td>Date of birth: </td>
                          <td>{selected?.birthDate} </td>
                        </tr>
                        <tr>
                          <td>Email: </td>
                          <td>{selected?.email}</td>
                        </tr>
                        {showother && (
                          <tr>
                            <td>Type of document: </td>
                            <td>{selected?.documentTypeId}</td>
                          </tr>
                        )}
                        {showother && (
                          <tr>
                            <td>Document number: </td>
                            <td>{selected?.documentId}</td>
                          </tr>
                        )}
                        {showother && (
                          <tr>
                            <td>Phone: </td>
                            <td>{selected?.phone}</td>
                          </tr>
                        )}
                        {showother && (
                          <tr>
                            <td>Mobile: </td>
                            <td>{selected?.mobile}</td>
                          </tr>
                        )}
                        {showother && (
                          <tr>
                            <td>Fax: </td>
                            <td>{selected?.fax}</td>
                          </tr>
                        )}
                        {showother && (
                          <tr>
                            <td>Nation: </td>
                            <td>{selected?.nation}</td>
                          </tr>
                        )}
                        {showother && (
                          <tr>
                            <td>Country/State: </td>
                            <td>{selected?.country}</td>
                          </tr>
                        )}
                        {showother && (
                          <tr>
                            <td>Town: </td>
                            <td>{selected?.town}</td>
                          </tr>
                        )}
                        {showother && (
                          <tr>
                            <td>Address: </td>
                            <td>{selected?.address}</td>
                          </tr>
                        )}
                        {showother && (
                          <tr>
                            <td>Time zone: </td>
                            <td>{selected?.timeZone}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    {!showother && (
                      <div class="text-center mb-5">
                        <button
                          type="button"
                          class="btn btn-outline-secondary"
                          onClick={() => setShowOther(true)}
                        >
                          Other
                        </button>
                      </div>
                    )}
                  </div>
                )}
                {isAdmin && (
                  <div class="manager_table">
                    <table class="table table-hover">
                      <tbody>
                        <tr>
                          <td>Name: </td>
                          <input type="text" value={selected?.name} />
                        </tr>
                        <tr>
                          <td>Surname: </td>
                          <input type="text" value={selected?.surname} />
                        </tr>
                        <tr>
                          <td>Gender: </td>
                          <div>
                            <select value={selected?.sex}>
                              <option value="M">Male</option>
                              <option value="F">Female</option>
                            </select>
                          </div>
                        </tr>
                        <tr>
                          <td>Language: </td>
                          <div>
                            <select value={selected?.language}>
                              <option value="en_GB">English</option>
                            </select>
                          </div>
                        </tr>
                        <tr>
                          <td>Date of birth: </td>
                          <input
                            type="date"
                            id="birthday"
                            name="birthday"
                            value={selected?.birthDate}
                          ></input>
                        </tr>
                        <tr>
                          <td>National Insurance number: </td>
                          <input type="text" />
                        </tr>
                        <tr>
                          <td>Nation: </td>
                          <input type="text" value={selected?.nation} />
                        </tr>
                        <tr>
                          <td>Country/State: </td>
                          <input type="text" value={selected?.country} />
                        </tr>
                        <tr>
                          <td>Town: </td>
                          <input type="text" value={selected?.town} />
                        </tr>
                        <tr>
                          <td>Email: </td>
                          <input type="text" value={selected?.email} />
                        </tr>
                        <tr>
                          <td>Type of document: </td>
                          <div>
                            <select value={selected?.documentTypeId}>
                              <option value="1">Id Card</option>
                            </select>
                          </div>
                        </tr>
                        <tr>
                          <td>Document number: </td>
                          <input type="text" value={selected?.documentId} />
                        </tr>
                        <tr>
                          <td>Phone: </td>
                          <input type="text" value={selected?.phone} />
                        </tr>
                        <tr>
                          <td>Mobile: </td>
                          <input type="text" value={selected?.mobile} />
                        </tr>
                        <tr>
                          <td>Fax: </td>
                          <input type="text" value={selected?.fax} />
                        </tr>
                        <tr>
                          <td>Time zone: </td>
                          <td>{selected?.timeZone}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>

            <div class="col-md-4">
              <div class="left_manager full_manager_div">
                <div class="box_effect">
                  <h3>USER DETAIL</h3>
                </div>

                <div class="mt-3">
                  <div class="row">
                    <div class="col-md-6">
                      <input
                        class="form-control mt-3"
                        type="text"
                        value={
                          selected?.type == -1
                            ? "VISITOR:VISITOR"
                            : selected?.type == 0
                            ? "FINANCIAL:FINANCIAL"
                            : selected?.type == 1
                            ? "TRADER:TRADER"
                            : selected?.type == 2
                            ? "USER:USER"
                            : selected?.type == 3
                            ? "OPERATOR:OPERATOR"
                            : selected?.type == 4
                            ? "AGENCY:AGENCY"
                            : ""
                        }
                        aria-label="Disabled input example"
                        disabled
                        readonly
                      />

                      <input
                        class="form-control mt-3"
                        type="text"
                        value={`Created on: ${moment(
                          selected?.insertionTime
                        ).format("MMMM d, YYYY")}`}
                        aria-label="Disabled input example"
                        disabled
                        readonly
                      />
                    </div>
                    <div class="col-md-6">
                      {/* <span
                        class="form-control mt-3"
                        style={{
                          backgroundColor:
                            selectAmountInput == "Gold" ? "#e9ecef" : "white",
                          opacity: "1",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setSelectAmountInput("Gold");
                        }}
                      >
                        {`Gold Coin: ${selected?.account?.gc_balance || ""}`}
                      </span>
                      <span
                        class="form-control mt-3"
                        style={{
                          backgroundColor:
                            selectAmountInput == "sagaCoin"
                              ? "#e9ecef"
                              : "white",
                          opacity: "1",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setSelectAmountInput("sagaCoin");
                        }}
                      >
                        {`Saga Coin:  ${selected?.account?.sc_credit || 0}`}
                      </span> */}
                      <span
                        class="form-control mt-3"
                        style={{
                          backgroundColor:
                            selectAmountInput == "balance"
                              ? "#e9ecef"
                              : "white",
                          opacity: "1",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setSelectAmountInput("balance");
                        }}
                      >
                        {`Balance: ${selected?.account?.balance || 0}`}
                      </span>
                      <span
                        class="form-control mt-3"
                        style={{
                          backgroundColor:
                            selectAmountInput == "bonus_balance"
                              ? "#e9ecef"
                              : "white",
                          opacity: "1",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setSelectAmountInput("bonus_balance");
                        }}
                      >
                        {`Bonus Balance: ${selected?.account?.bonus_balance || 0}`}
                      </span>
                      {/* <span
                        class="form-control mt-3"
                        style={{
                          backgroundColor:
                            selectAmountInput == "redeemSagaCoin"
                              ? "#e9ecef"
                              : "white",
                          opacity: "1",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setSelectAmountInput("redeemSagaCoin");
                        }}
                      >
                        {`Redeem Saga Coin: ${selected?.account?.sc_main || 0}`}
                      </span> */}
                    </div>
                  </div>

                  {/* <div class="row">
                    <div class="col-md-6"></div>
                    <div class="col-md-6">
                      <span
                        class="form-control mt-3"
                        style={{ backgroundColor: "#e9ecef", opacity: "1" }}
                      >
                        {`Total Saga Coin:
                        ${sumSC_credit_SC_Main(
                          selected?.account?.sc_credit,
                          selected?.account?.sc_main
                        )}
                        `}
                      </span>
                    </div>
                  </div> */}

                  <div class="row">
                    {/* <div class="col-md-6">
                      <input
                        class="form-control mt-3"
                        type="text"
                        value={moment(selected?.insertionTime).format(
                          "MMMM d, YYYY"
                        )}
                        aria-label="Disabled input example"
                        disabled
                        readonly
                      />
                    </div> */}
                  </div>
                </div>

                <div class="sub_manager mt-4">
                  <h3>Transfer</h3>
                </div>
                <div class="manager_table">
                  <table class="table table-hover">
                    <tbody>
                      <tr>
                        <td>Coins: </td>
                        <td>
                          <input
                            type="text"
                            name=""
                            value={amountEnter}
                            onChange={handleChange}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td> Coin Type </td>
                        <td>
                          <div class="form-check form-check-inline">
                            <div key={`inline-radio`} className="mb-3">
                              {/* <Form.Check
                                inline
                                label="Gold coin"
                                name="group1"
                                type={"radio"}
                                id={`inline-radio-1`}
                                onChange={(e) => {
                                  setChecked(e.target.checked);
                                  setType("gc_balance");
                                }}
                              />
                              <Form.Check
                                inline
                                label="Saga Coin"
                                name="group1"
                                type={"radio"}
                                id={`inline-radio-1`}
                                onChange={(e) => {
                                  setChecked(e.target.checked);
                                  setType("sc_credit");
                                }}
                              /> */}
                              <Form.Check
                                inline
                                label={`Cash Balance (${selected?.account?.balance || 0})`}
                                name="group1"
                                type={"radio"}
                                id={`inline-radio-1`}
                                onChange={(e) => {
                                  setChecked(e.target.checked);
                                  setType("cash");
                                }}
                              />
                              <Form.Check
                                inline
                                label={`Bonus Balance (${selected?.account?.bonus_balance || 0})`}
                                name="group1"
                                type={"radio"}
                                id={`inline-radio-1`}
                                onChange={(e) => {
                                  setChecked(e.target.checked);
                                  setType("bonus");
                                }}
                              />
                              {/* <Form.Check
                                inline
                                label="Redeem Saga Coin"
                                name="group1"
                                type={"radio"}
                                id={`inline-radio-1`}
                                onChange={(e) => {
                                  setChecked(e.target.checked);
                                  setType("sc_main");
                                }}
                              /> */}
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td> Request Type </td>
                        <td>
                          <div class="form-check form-check-inline">
                            <div key={`inline-radio`} className="mb-3">
                              <Form.Check
                                inline
                                label="Deposit"
                                name="group2"
                                type={"radio"}
                                id={`inline-radio-2`}
                                onChange={(e) => {
                                  setrequestChecked(e.target.checked);
                                  setRequestType("Deposit");
                                }}
                              />
                              <Form.Check
                                inline
                                label="Withdraw"
                                name="group2"
                                type={"radio"}
                                id={`inline-radio-2`}
                                onChange={(e) => {
                                  setrequestChecked(e.target.checked);
                                  setRequestType("WithDraw");
                                }}
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                      {/* <tr>
                        <td> Hide User Transaction </td>
                        <td>
                          <div class="form-check form-check-inline">
                            <div key={`inline-radio`} className="mb-3">
                              <Form.Check
                                inline
                                // label="Tick"
                                name="group1"
                                type="checkbox"
                                id="inline-checkbox-1"
                                value={hideTransChecked}
                                onChange={(e) =>
                                  setHideTransChecked(e.target.checked)
                                }
                              />
                            </div>
                          </div>
                        </td>
                      </tr> */}
                      <tr>
                        <td>Description: </td>
                        <td>
                          <input
                            type="text"
                            name="description"
                            value={description}
                            onChange={(event) => {
                              setDescription(event.target.value);
                            }}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="text-center mb-5">
                    <button
                      type="button"
                      disabled={selected?.idUser ? false : true}
                      class="btn btn-outline-secondary"
                      onClick={WithdrawDeposit}
                    >
                      Perform
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-5">
              <div class="left_manager full_manager_div">
                <div class="box_effect">
                  <h3>All USERS </h3>
                </div>
                <div style={{  }}>
                  <div style={{ fontWeight: "bold" }}>
                    {"Search By UserName,UserId,Name and Email "}
                    <input
      
                      type="text"
                      className="form-control form-control-md"
                      placeholder="Search By UserName,UserId,Name and Email"
                      value={searchQuery}
                      onChange={(e) => {
                        filterList(e);
                      }}
                      style={{ marginBottom: "3px", marginTop: "3px" ,}}
                    />
                  </div>
                  <button
                    type="button"
                    disabled={
                      searchQuery == "" ?  true: false
                    }
                    class="btn btn-outline-secondary"
                    onClick={()=>{
                       seacrhUser()
                    }}
                  >
                    Search
                  </button>
                </div>
                

                <div class="manager_table2">
                  <table class="table table-hover">
                    <tbody>
                      {/* <td style={{ fontWeight: "bold" }}>
                          {"Id "}
                          <input
                            type="text"
                            className="form-control form-control-md"
                            placeholder="Search"
                            onChange={(e) => {
                              filterList2(e);
                            }}
                            style={{ marginBottom: "3px", marginTop: "3px" }}
                          />
                        </td>
                       
                        <td style={{ fontWeight: "bold" }}>
                          {"Email "}
                          <input
                            type="text"
                            className="form-control form-control-md"
                            placeholder="Email"
                            onChange={(e) => {
                              filterList3(e);
                            }}
                            style={{ marginBottom: "3px", marginTop: "3px" }}
                          />
                        </td> */}

                      {allusers.map((item, index) => {
                        if (
                          item.idUser != admin?.idUser &&
                          item.idUser != riskmng?.idUser
                        ) {
                          return (
                            <tr onClick={() => onUserClick(item)}>
                              <td>
                                <label
                                  style={{ cursor: "pointer" }}
                                  onClick={() => onUserClick(item)}
                                >
                                  {" "}
                                  {item.login}
                                </label>
                              </td>

                              <td>
                                <label
                                  style={{ cursor: "pointer" }}
                                  onClick={() => onUserClick(item)}
                                >
                                  {" "}
                                  {item.idUser}
                                </label>
                              </td>

                              <td>
                                <label
                                  style={{ cursor: "pointer" }}
                                  onClick={() => onUserClick(item)}
                                >
                                  {item.email}
                                </label>
                              </td>
                            </tr>
                          );
                        }
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Transfer;
